<script setup lang="ts">
import './assets/style.scss'
import { VContentGridItem } from '@/shared/ui'
import { useModel } from './../model/model.ts'
import { useSseConnection } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { watch } from 'vue'
import { useAuth } from '@/entities/Auth'

defineOptions({ name: 'events' })

const { filter, headers, data, total, perPageList, loadData } = useModel()
const { isFetching, refetch } = loadData()
const route = useRoute()
const auth = useAuth()

/* Устанавливаем SSE соединение */
const { handler: eventsHandler } = useSseConnection((res: any) => {
  if (res.type && res.type === 'events' && res.content.object.id == route.params.object_id) {
    refetch()
  }
})

watch(
  () => auth.user?.user_id,
  () => {
    if (auth.user) {
      eventsHandler(`/user/${auth.user.user_id}/events`)
    }
  },
  { immediate: true },
)
</script>

<template>
  <VContentGridItem :title="$t('itf.events_errors_last')">
    <VDataTableServer
      class="table_hover"
      v-model:items-per-page="filter.per_page"
      v-model:page="filter.page"
      :loading="isFetching"
      :headers="headers"
      :items="data"
      :items-length="total"
      :items-per-page-options="perPageList"
      :no-data-text="$t('itf.not_data_per_day')"
      @update:options="refetch"
      density="comfortable"
    ></VDataTableServer>
  </VContentGridItem>
</template>
